module.exports = __webpack_public_path__ + "img/bear6.f0c46b04.png";